define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var server = require('server');
    var user = require('user');
    var apiModule = require('modules/api/api');
    var core = require('core');
    var storage = require('util/storage.util');
    const config = require('config');
    const fetchUtil = require('util/fetch.util');
    const $ = require('j');

    core.once('app:initialResourcesLoaded', function() {
        const events = storage.session.getItem('core_events') || {};

        for (let key in events) {
            core.trigger(key, events[key]);
        }

        storage.session.removeItem('core_events');
    });

    module.exports = _.extend(apiModule, {
        /**
         * Returns regulation status
         */
        sendUserRegulationStatusRequest: function() {
            var request = {
                ID: 35691,
                description: 'Get User Regulation Status',
                responses: [35692, 35693],
            };

            return server.send(request).done(function(response) {
                const regulationStatus = response.data?.playerRegulationStatusHistory?.[0]?.code;
                user.set({regulationStatus: regulationStatus});

                return response?.data?.playerRegulationStatusHistory;
            });
        },

        getGamesContextByBonusCode: function(bonusCode) {
            const bonusesConfiguration = config.get('bonusesConfiguration');
            const bonusInfo = bonusesConfiguration.filter(el => el.bonusCode === bonusCode) && bonusesConfiguration.filter(el => el.bonusCode === bonusCode)[0]?.detailedViewWebContentId;

            if (!bonusInfo) {
                console.error(`There is no bonus with bonusCode ${bonusCode}`);
                return;
            }

            const loadContent = async (contentId) => {
                const deferred = $.Deferred();
                const url = '/webContent/' + user.get('lang') + '_' + contentId;

                if (!contentId) {
                    return deferred.resolve('');
                }

                return fetchUtil.fetch({
                    url: url,
                    dataType: 'html'
                });
            };

            const loadBonusContent = async (innerContent) => {
                if (innerContent.includes('data-game-code') && innerContent.split('data-game-code').filter(el => el.startsWith('='))) {
                    return innerContent.match(/(data-game-code(?:[^>]*)>)/ig)
                        .map(el => el.slice(el.indexOf('=') + 1 , el.indexOf('>')).replaceAll(/"/g, ''))
                        .map(el => el.indexOf(' ') === -1 ? el : el.slice(0, el.indexOf(' ')));
                }
            };

            const showResult = async (bonusWebContent) => {
                const getBonusWebContent = await loadContent(bonusWebContent);
                const getGameCodesFromContent = await loadBonusContent(getBonusWebContent);
                const gamesConfig = await Playtech.API.game.getGamesConfiguration();

                if (!getGameCodesFromContent) {
                    console.error(`There is no games inside ${bonusWebContent} web-content`);
                    return;
                }

                return getGameCodesFromContent.map(el => gamesConfig.gamesConfiguration[el]);
            };

            return showResult(bonusInfo).then(items => items);
        },

        sendDetailedBalanceHistory: function(correlationId, balanceTypes, startDate, endDate) {
            var request = {
                ID: 35784,
                description: "Get Detailed Balance History",
                correlationId: correlationId,
                balanceTypes: balanceTypes,
                startDate: startDate,
                endDate: endDate,
                responses: [35785, 35786]
            };

            return server.send(request).done(function(response) {
                return response.data;
            });
        },

        callOAPI: function(callParameters) {
            return server.send(callParameters)
                .done(function(response) {
                    return response.data;
                })
                .fail(console.error);
        },

        sendChatInitialization: function(serverUrl) {
            var request = {
                ID: 72057,
                responses: [72058, 72059],
                description: 'Request chat initialization',
                correlationId: _.uniqueId(),
                serverUrl: serverUrl
            };

            server.send(request).done(function(response) {
                if (response && response.data && response.data.jwtToken) {
                    var jwtToken = response.data.jwtToken;

                    window.zESettings = {
                        webWidget: {
                            authenticate: {
                                chat: {
                                    jwtFn: function(callback) {
                                        if (jwtToken) {
                                            callback(jwtToken);
                                            /* eslint-disable no-undef */
                                            showZDChat();
                                            /* eslint-enable no-undef */
                                        }
                                    }
                                }
                            }
                        }
                    };

                    window.zE('webWidget', 'updateSettings', window.zESettings);

                    window.zE('webWidget', 'chat:reauthenticate');
                }
            }).fail(console.error);

        },

        sendBalanceHistory: function(startDate, endDate, returnSummary) {
            var request = {
                ID: 32012,
                description: "Get Balance History",
                endDate: endDate,
                ignorePlayerViewConf: true,
                orderByDate: "desc",
                pagerRequest: {pageSize: 30, returnTotalCount: true},
                returnSummary: returnSummary,
                startDate: startDate,
                responses: [32013, 32014]
            };

            return server.send(request).done(function(response) {
                return response.data;
            });
        },

        getUserRegulationStatus: function() {
            this.sendUserRegulationStatusRequest();
            return user.get('userRegulationStatusHistory');
        }
    });
});

